import { usePresence } from '@accounts/session';

/**
 * The line beside a destructive action the person pressed while their session had ended: it was not
 * sent, and is pressed again (the family's session rule, D63). Not a failure: the session's dialog
 * already said what happened, so this is a status line in the session's own words. It takes a line of
 * its own; `end` aligns it with actions that end the line, in a list row or a section's heading.
 */
export function Unsent({ shown, end = false }: { shown: boolean; end?: boolean }) {
	const { unsent } = usePresence();
	if (!shown) return null;
	return (
		<p role="status" className={`basis-full text-small text-ink-muted ${end ? 'text-end' : ''}`} data-session-unsent="">
			{unsent}
		</p>
	);
}
